import store from 'src/store/intum-store'
import router from 'src/intum-router'
import App from 'components/common/RouterApp.vue'
// import App from 'components/tmp/EmptyApp.vue'
import initVue from 'src/app'
console.log('intum app...')
initVue({ app: App, router: router, store: store })
